<template>
    <div id="pierre-cardin-alert">
        <div class="alert-container">
            <div class="text">
                {{ text }}
            </div>
            <div class="buttons">
                <Button
                    @btnClicked="() => $emit('cancel')"
                    :txtColor="'var(--form-color-text)'"
                    :size="'medium'"
                    :bgColor="'white'"
                    :borderRadius="'10px'"
                    :paddingY="'2px'"
                    ><span style="color: var(--form-color-text) !important">
                        <span style="color: black; font-weight: 100"> {{ $t("message.no") }}</span>
                    </span>
                </Button>
                <Button
                    @btnClicked="() => $emit('ok')"
                    :size="'medium'"
                    :bgColor="'white'"
                    :borderRadius="'10px'"
                    :paddingY="'2px'"
                >
                    <span style="color: var(--form-color-text) !important">
                        <span style="color: black; font-weight: 100"> {{ $t("message.yes") }}</span>
                    </span>
                </Button>
            </div>
            <div class="svg-container">
                <PierreCardin style="width: 150px !important; height: 350px !important" />
            </div>
        </div>
    </div>
</template>
<script>
import Button from "../../../common/Button.vue";
import DynamicSvg from "../../../common/DynamicSvg.vue";
import PierreCardin from "./asset/PierreCardin.vue";
import { mapState } from "vuex";
import _ from "lodash";
import { sendCommandToParentWindow } from "../../../utils/parentWindowConnection";

export default {
    name: "PierreCardinAlert",
    props: ["text", "iconName"],
    components: { DynamicSvg, Button, PierreCardin },
    data() {
        return {};
    },

    methods: {},
    computed: {
        ...mapState({
            visitingPage: (state) => state.app.visitingPage,
            settings: (state) => state.setting.settings,
        }),
    },
    mounted() {
        const color = _.get(this.settings, "chatCustomizationSettings.versionV2Theme.colors.backgroundColorFirst");
        if (color) {
            sendCommandToParentWindow("visible-window-bg", { color });
        }
    },
    beforeDestroy() {
        const color = _.get(this.settings, "chatCustomizationSettings.versionV2Theme.colors.backgroundColorFirst");
        sendCommandToParentWindow("visible-window-bg", { color });
    },
};
</script>
<style scoped lang="scss">
#pierre-cardin-alert {
    background-color: var(--background-color-first);
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0px;

    .alert-container {
        margin-top: 80px;

        .svg-container {
            max-width: 100%;
            display: flex;
            justify-content: center;

            svg {
                max-width: 350px !important;
            }

            @media (min-width: 981px) {
                margin-top: 20%;
            }
        }

        .text {
            font-weight: 600;
            font-size: 18px;
            line-height: 32px;
            margin-bottom: 20px;
            text-align: center;
            padding: 10px 20px 0px;
        }

        .buttons {
            display: flex;
            justify-content: center;
            align-items: center;

            #button {
                font-size: 16px;
                font-weight: 700;
                line-height: 20px;
                letter-spacing: 0em;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/uspaV2/PierreCardinAlert.vue